module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Psychic.29f02cc0.png";